import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Lookup/lookup.service';
import { HelperService } from 'src/app/services/Helper/helper.service';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { ResetPasswordParameters } from 'src/app/models/ui/ChangePasswordParameters';
import { User } from 'src/app/models/ui/User';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-user-management-admin',
  templateUrl: './user-management-admin.component.html',
  styleUrls: ['./user-management-admin.component.css']
})
export class UserManagementAdminComponent implements OnInit {
  isAuthorized: string;

  loadingVisible = false;

  users: any[];
  contractTypes: any[];
  roles: any[];
  assignedRoles: any[];
  status: any[];
  countries: any[];
  providerId: string;

  userToUpdate: User;

  resetPasswordParameters: ResetPasswordParameters;

  userRegex: any;
  emailRegex: any;
  phoneRegex: any;

  isValid: boolean;

  constructor(private router: Router, private helper: HelperService, private lookupService: LookupService, private userService: UserService) {
    this.resetPasswordParameters = new ResetPasswordParameters();
    this.userToUpdate = new User();
  }

  ngOnInit() {
    var currentUserRole = localStorage.getItem("UserRole");
    if (currentUserRole !== '8') {
      location.assign("#/home");
    }
    else {

      this.isAuthorized = localStorage.getItem("isAuthorized");

      if (this.isAuthorized === "true") {
        this.helper.setTitle('Provider - User Management');

        this.lookupService.getUsers().subscribe(data => this.users = data);
        this.lookupService.getRoles().subscribe(data => this.roles = data);

        this.lookupService.getContractTypes().subscribe(data => this.contractTypes = data);
        this.lookupService.getStatus().subscribe(data => this.status = data);
        this.lookupService.getRoles().subscribe(data => this.assignedRoles = data);
        this.lookupService.getCountries().subscribe(data => this.countries = data);
      }
      else
        location.assign("#/login-form");
    }
  }

  resetPassword(e) {
    this.resetPasswordParameters.Username = e.key.UserName;
    this.resetPasswordParameters.PhoneNumber = e.key.PhoneNumber;
    this.userService.resetPassword(this.resetPasswordParameters).subscribe(data => notify(data));
  }

  createUser(e) {
    this.isValid = this.checkFormats(e.data);
    if (this.isValid == true) {
      this.loadingVisible = true;
      e.data.ProviderId = localStorage.getItem("currentProvider");
      this.userService.createUser(e.data).subscribe(data => this.displayResult(data));
    }
  }

  updateUser(e) {
    this.userToUpdate = e.key;
    this.userToUpdate.SessionTokenKey = localStorage.getItem("currentSessionTokenKey");
    this.isValid = this.checkFormats(this.userToUpdate);
    if (this.isValid == true) {
      this.loadingVisible = true;
      this.userService.updateUser(this.userToUpdate).subscribe(data => this.displayResult(data));
    }
  }

  updateUserRole(e) {
    this.userToUpdate = e.key;
    this.userToUpdate.SessionTokenKey = localStorage.getItem("currentSessionTokenKey");
    //this.isValid = this.checkFormats(this.userToUpdate);
    //if(this.isValid == true) {
    this.loadingVisible = true;
    this.userService.updateUserRole(this.userToUpdate).subscribe(data =>
      this.displayResult(data)

    );
    //}
  }

  activateUser(e) {
    this.userService.activateUser(e.key).subscribe(data => this.displayResult(data));
  }

  unlockUser(e) {
    this.userService.unlockUser(e.key).subscribe(data => this.displayResult(data));
  }

  lockUser(e) {
    this.userService.lockUser(e.key).subscribe(data => this.displayResult(data));
  }

  displayResult(data) {
    this.loadingVisible = false;
    alert(data);
    setTimeout(() => {
      location.reload();
    }, 2000);
  }

  onEditorPreparing(e) {
    if (e.parentType == "dataRow" && e.dataField == "PhoneNumber") {
      e.editorOptions.placeholder = "05(X)XXXXXXX";
    }
  }

  checkFormats(userInfo) {
    this.userRegex = new RegExp("^[a-zA-Z0-9.]+$");
    this.emailRegex = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$");
    this.phoneRegex = new RegExp("^[0-9]{0,12}$");

    if (!userInfo.UserName.match(this.userRegex)) {
      alert("Your username contains invalid characters. Please use only alphanumeric characters and dots.");
      return false;
    }

    if (!userInfo.Email.match(this.emailRegex)) {
      alert("Your email contains invalid characters.");
      if (!userInfo.PhoneNumber.match(this.phoneRegex)) document.getElementById("phoneNumberBox").style.backgroundColor = "crimson";
      return false;
    }

    if (!userInfo.PhoneNumber.match(this.phoneRegex)) {
      alert("Your phone number contains invalid characters. Please follow the correct number format.");
      return false;
    }

    return true;
  }
}